module.exports = __webpack_public_path__ + "static/img/system1.221328a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/system1.jpg
// module id = cIbO
// module chunks = 6